import http from 'hub-http/clients/apiClient';
export const getIdentificationToken = () => {
  return http.post('helpdesk-integration/v1/messages/tokens/create');
};